import { Photo } from 'dealer-types'
import React from 'react'
import View from '../atoms/View'
import Space from '../atoms/Space'
import { Item } from 'react-photoswipe-gallery'
interface Props {
  photos: Photo[]
}

const GallerySection = ({ photos }: Props): JSX.Element => {
  const [firstPhoto, ...restPhotos] = photos
  if (typeof firstPhoto === 'undefined') return <></>
  return (
    <View className="flex h-full">
      <View className="w-full h-full rounded-4 overflow-hidden">
        <Item
          id={firstPhoto.id}
          original={firstPhoto.file.url}
          thumbnail={firstPhoto.file.url}
          cropped={true}
          width={firstPhoto.file.width}
          height={firstPhoto.file.height}>
          {({ ref, open }) => (
            <img
              ref={ref}
              className="object-cover w-full h-full cursor-pointer"
              src={firstPhoto.file.url}
              alt={firstPhoto.id.toString()}
              onClick={open}
            />
          )}
        </Item>
      </View>
      <Space x={2} />
      <View className="overflow-scroll w-[150px] hide-scrollbar">
        <View className="flex flex-col gap-4">
          {restPhotos.map((photo) => (
            <View
              key={photo.id}
              className="w-[120px] rounded-2 overflow-hidden shadow-xl shadow-[black] shadow-bothSmall">
              <Item
                key={photo.id}
                id={photo.id}
                original={photo.file.url}
                thumbnail={photo.file.url}
                cropped={true}
                width={photo.file.width}
                height={photo.file.height}>
                {({ ref, open }) => (
                  <div key={photo.id} ref={ref}>
                    <img className="w-full h-full rounded-2 cursor-pointer" src={photo.file.thumb.url} onClick={open} />
                  </div>
                )}
              </Item>
            </View>
          ))}
        </View>
      </View>
    </View>
  )
}

export default GallerySection
